import Svg, { SvgProps } from './Svg';

export default function DownIcon({
  color = 'currentColor',
  ...props
}: SvgProps) {
  return (
    <Svg
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}>
      <path d="M6.00005 11L12.0001 17M12.0001 17L18.0001 11M12.0001 17V3M5 21H19" />
    </Svg>
  );
}
